module.exports = function getResource(label, vars = []) {
    let resources = {
        default: 'Default',
        sort: 'Sort',
        sortBy: 'Sort by'
    };

    return resources[label];
};
